import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("mlily_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default api;

export const AU_STATES = ["NSW", "VIC", "QLD", "SA", "WA", "TAS", "NT", "ACT"];

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  management: "Management",
  general_manager: "General Manager",
  sales_agent: "Sales Agent",
  customer_service: "Customer Service",
};

export const STATUS_STYLES = {
  Active: "badge-active",
  Inactive: "badge-inactive",
  "No Sale This Month": "badge-warning",
  "Follow-up Required": "badge-warning",
  "New Customer": "badge-info",
  "Returning Customer": "badge-info",
  "Declining Customer": "badge-danger",
};

export const money = (n) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD", maximumFractionDigits: 0 }).format(n || 0);

export const shortDate = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return d; }
};
